import { get } from 'lodash';
import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { CatalogWithExternalEntitiesDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { RecContentItemDto } from '../../apis/rec-gateway/rec-gateway.dtos';
import { PrimaryTaxonomy } from '../../apis/rec-gateway/rec-gateway.models';
import { EvolveProductDto } from '../../apis/sherpath-app-facade-service/sherpath-app-facade-service.dtos';
import {
  getSubtitle,
  getTitle
} from '../catalog/catalog.utilities';
import { MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH } from '../course-plan/syllabus.constants';

export const getSimulationExerciseAssignmentInfo = (
  catalog: CatalogWithExternalEntitiesDto,
  contentItem: RecContentItemDto,
  primaryTaxonomies: PrimaryTaxonomy[],
  evolveProducts: EvolveProductDto[]
): Partial<AssignmentDto> => {
  const contentId = get(contentItem, 'attributes.contentId', null);

  // Note: assignmentQuestions and goal are not available from catalog data.
  // They will be fetched from EOLS Collection Object Data API via fetchEolsCollectionObjectDataAction
  // in commonAssignmentInfoHandler, and goal will be set to the total question count.
  return {
    assignmentGoals: [{
      id: null,
      goal: null,
      vtwId: contentId,
      text: null,
    }],
    assignmentTopics: [],
    assignmentQuestions: [],
    title: contentItem ? getTitle(contentItem, catalog, primaryTaxonomies, MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH) : '',
    subtitle: contentItem ? getSubtitle(contentItem, catalog, primaryTaxonomies, evolveProducts, MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH) : '',
    contentId
  };
};
